import React from 'react';

import PropTypes from 'prop-types';

import { CREATE_NEW_VALUE } from '@src/config/collaterals';

import HookFormSelect from './HookFormSelect';

const HookFormSelectWithCreateNew = ({
    name,
    label,
    isRequired,
    control,
    errors,
    title,
    className,
    options = [],
    loading = false,
    loadingText,
    defaultValue,
    onValueChange,
    showCreateNew = true,
    createNewText = 'Create a new option',
}) => {
    const finalOptions = [...options];

    if (showCreateNew) {
        finalOptions.push({
            value: CREATE_NEW_VALUE,
            label: createNewText,
        });
    }

    return (
        <HookFormSelect
            name={name}
            label={label}
            isRequired={isRequired}
            control={control}
            errors={errors}
            title={title}
            className={className}
            options={finalOptions}
            loading={loading}
            loadingText={loadingText}
            defaultValue={defaultValue}
            onValueChange={onValueChange}
        />
    );
};

HookFormSelectWithCreateNew.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    isRequired: PropTypes.bool,
    control: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    title: PropTypes.string,
    className: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        }),
    ),
    loading: PropTypes.bool,
    loadingText: PropTypes.string,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onValueChange: PropTypes.func,
    showCreateNew: PropTypes.bool,
    createNewText: PropTypes.string,
};

export default HookFormSelectWithCreateNew;
